$('.banner-slider').owlCarousel({
  loop:false,
  nav:false,
  dots:true,
  responsiveClass:true,
  items:1
});

$('#home-main-banner').owlCarousel({
  loop:true,
  nav:false,
  dots:true,
  responsiveClass:true,
  autoplay:true,
  autoplayTimeout:5000,
  items:1
});


$( document ).ready(function() {
  $(".head_all_cat h3").click(function(){
    $(".head_all_cat .all_cat_listing").toggleClass("active");
  });
  if($(".qty_pr_js").length){
    //setTimeout(function(){ $(".qty_pr_js").val(1); }, 2000);
  }
  
});

// javascript for the esc to div hide

var button = $( '.head_all_cat' )[0];
var elem = $( '.all_cat_listing' )[0];

$( button ).on( 'click', function ( e ) {
    $( elem ).show();
    e.stopPropagation();
});

$( document ).on( 'click', function ( e ) {
    if ( $( e.target ).closest( elem ).length === 0 ) {
        $( elem ).hide();
    }
});
                
$( document ).on( 'keydown', function ( e ) {
    if ( e.keyCode === 27 ) {
        $( elem ).hide();
    }
});

// end